import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetContactUs() {
  const URL = endpoints.homepage.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      contactUs: data?.data || [],
      contactUsLoading: isLoading,
      contactUsError: error,
      contactUsValidating: isValidating,
      contactUsEmpty: !isLoading && !data?.data.length,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ---------------------------------------------------------------------

export function useGetContactUsWithFilter(filter) {
  let URL;
  if (filter) {
    URL = endpoints.contactUs.filterList(filter);
  } else {
    URL = endpoints.contactUs.list;
  }

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher);

  const refreshFilterContactUs = () => {
    // Use the `mutate` function to trigger a revalidation
    mutate();
  };

  return {
    filteredContactUs: data || [],
    filteredContactUsLoading: isLoading,
    filteredContactUsError: error,
    filteredContactUsValidating: isValidating,
    filteredContactUsEmpty: !isLoading && !data?.length,
    refreshFilterContactUs, // Include the refresh function separately
  };
}